import { useEffect, useRef } from 'react';

import clsx from 'clsx';

import { Container } from '@src/ui/components/Container';

import CheckCircleIcon from '../Icons/CheckCircleIcon';
import PhoneCallIcon from '../Icons/PhoneCallIcon';

const classes = {
    wrapper: 'p-3 bg-almond-200 h-11 border-t border-almond-500',
    offerWrapper: 'p-3 bg-almond-200 h-11 sm:mb-2 border-t border-almond-500',
    container:
        'flex justify-center lg:justify-between -mt-0.5 items-center text-sm text-steel-40',
};

export interface TrustbarProps {
    className?: string;
    showTrustbarV2?: boolean;
    phoneNumber?: string;
    showSavedPreferencesBanner?: boolean;
}

const Trustbar = ({
    className,
    showTrustbarV2,
    phoneNumber,
    showSavedPreferencesBanner,
}: TrustbarProps) => {
    const ref = useRef<HTMLDivElement>(null);
    const isFinalisePage = window.location.pathname.includes('finalise');
    const wrapperClassName = isFinalisePage
        ? clsx(classes.offerWrapper)
        : clsx(classes.wrapper, { 'sm:mb-12': !showSavedPreferencesBanner });

    const currentPhoneNumber = phoneNumber || '020 4525 8044';

    useEffect(() => {
        if (window.Trustpilot && ref.current) {
            window.Trustpilot.loadFromElement(ref.current);
        }
    }, [ref]);

    return (
        <>
            <Container className={clsx([className, wrapperClassName])}>
                <Container variant={'wide'} className={classes.container}>
                    {showTrustbarV2 ? (
                        <div className='lg:flex lg:justify-between w-full'>
                            <div className='transform scale-80 lg:-ml-9'>
                                <div
                                    ref={ref}
                                    className='tp-widget-trustscore mx-auto'
                                    data-locale='en-GB'
                                    data-template-id='5419b732fbfb950b10de65e5'
                                    data-businessunit-id='60fae03f0687800001e2a1da'
                                    data-style-height='20px'
                                    data-style-width='100%'
                                    data-text-color='#B0B3B5'
                                >
                                    <a
                                        href='https://uk.trustpilot.com/review/selinaadvance.com'
                                        target='_blank'
                                        rel='noopener noreferrer'
                                    >
                                        Trustpilot
                                    </a>
                                </div>
                            </div>
                            <div className='text-steel-100 items-center space-x-2 hidden lg:flex lg:order-2'>
                                <div className='flex'>
                                    <PhoneCallIcon />
                                    <p className='font-bold pl-2 text-md'>
                                        Need help?
                                    </p>
                                </div>
                                <p className='text-md'>
                                    {currentPhoneNumber} (Mon - Fri, 9am - 5pm)
                                </p>
                            </div>
                        </div>
                    ) : (
                        <>
                            <p className='hidden lg:block'>
                                Funding in as little as 48 hours
                            </p>
                            <div className='transform scale-80'>
                                <div
                                    ref={ref}
                                    className='tp-widget-trustscore mx-auto'
                                    data-locale='en-GB'
                                    data-template-id='5419b732fbfb950b10de65e5'
                                    data-businessunit-id='60fae03f0687800001e2a1da'
                                    data-style-height='20px'
                                    data-style-width='100%'
                                    data-text-color='#B0B3B5'
                                >
                                    <a
                                        href='https://uk.trustpilot.com/review/selinaadvance.com'
                                        target='_blank'
                                        rel='noopener noreferrer'
                                    >
                                        Trustpilot
                                    </a>
                                </div>
                            </div>
                            <p className='hidden lg:block'>
                                Authorised and regulated by the FCA
                            </p>
                        </>
                    )}
                </Container>
            </Container>
            {showSavedPreferencesBanner && (
                <div className='flex items-center justify-center gap-1 py-2 px-6 w-full bg-peppermint-200 mb-12'>
                    <CheckCircleIcon className='text-peppermint-900' />
                    <span className='text-sm font-sora-bold text-peppermint-900'>
                        Thanks, we&apos;ve saved your preferences
                    </span>
                </div>
            )}
        </>
    );
};

export default Trustbar;
